import { render } from "./QuotedPrice.vue?vue&type=template&id=022fe466&scoped=true&ts=true&lang=pug"
import script from "./QuotedPrice.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotedPrice.vue?vue&type=script&setup=true&lang=ts"

import "./QuotedPrice.vue?vue&type=style&index=0&id=022fe466&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022fe466"]])

export default __exports__